import React, { useState, useEffect } from "react";
import { CKEditor } from "ckeditor4-react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "./TabPanel";
// import useAlerts from "../../utility/alerts";
import useAlerts from "../../utility/alerts";
import ApiRequest from "../../utility/http";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";

export const AdminForm = ({
  //   initialData = {},
  verticalScroll = 0,
  updateFormData,
}) => {
  //  CONSTANTS

  const [prefix, setPrefix] = useState("");
  const [suffix, setSuffix] = useState("");
  const [reason, setReason] = useState("");
  const [ethnicity, setEthnicity] = useState("");
  const [parkingPrefix, setParkingPrefix] = useState("");
  const [parkingSuffix, setParkingSuffix] = useState("");

  // console.log("parkingPrefix", parkingPrefix)
  // console.log("parkingSuffix", parkingSuffix)
  const Alert = useAlerts();

  const [tabValue, setTabValue] = useState(0);

  //   //  METHODS
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const handleSubmitNamePrefix = async (e) => {
    e.preventDefault();
    try {
      const res = await ApiRequest.post("/public/api/auth/name-prefix", {
        prefix,
      });
      console.log("here ", res);
      setPrefix("");
      if (res.status == 200) {
        await Alert.addSuccess("Name prefix is added!");
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleSubmitNameSuffix = async (e) => {
    e.preventDefault();
    try {
      const res = await ApiRequest.post("/public/api/auth/name-suffix", {
        suffix,
      });
      if (res.status == 200) {
        await Alert.addSuccess("Name suffix is added!");
      }
      setSuffix("");
    } catch (err) {
      console.log(err);
    }
  };
  const handleSubmitParkingPrefix = async (e) => {
    e.preventDefault();
    try {
      const res = await ApiRequest.post(
        "/public/api/auth/parking-space-prefix",
        {
          prefix: parkingPrefix,
        }
      );
      if (res.status == 200) {
        await Alert.addSuccess("Parking prefix is added!");
      }
      setParkingPrefix("");
    } catch (err) {
      console.log(err);
    }
  };
  const handleSubmitParkingSuffix = async (e) => {
    e.preventDefault();
    try {
      const res = await ApiRequest.post(
        "/public/api/auth/parking-space-suffix",
        {
          suffix: parkingSuffix,
        }
      );
      if (res.status == 200) {
        await Alert.addSuccess("Parking suffix is added!");
      }
      setParkingSuffix("");
    } catch (err) {
      console.log(err);
    }
  };
  const handleSubmitMoveOutReason = async (e) => {
    e.preventDefault();
    try {
      const res = await ApiRequest.post("/public/api/auth/moveout-reason", {
        reason,
      });
      if (res.status == 200) {
        await Alert.addSuccess("Moveout reason is added!");
      }
      setReason("");
    } catch (err) {
      console.log(err);
    }
  };
  const handleSubmitEthnicities = async (e) => {
    e.preventDefault();
    try {
      const res = await ApiRequest.post("/public/api/auth/ethnicity", {
        ethnicity,
      });
      if(res.status == 200){
        await Alert.addSuccess("Ethnicities is added!");
      };
      setEthnicity("");
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //   if (alertList?.length) {
  //     alertList.map((alertEl) => {
  //       Alert.show(alertEl);
  //       Alert.remove(alertEl);
  //     });
  //   }
  // }, [alertList]);
  return (
    <>
      {/* Add Property Form  */}

      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="basic tabs example"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
      >
        <Tab label="Name settings" {...a11yProps(0)} />
        <Tab label="Parking space settings" {...a11yProps(1)} />
        <Tab label="Moveout settings" {...a11yProps(2)} />
        <Tab label="Ethnicities settings" {...a11yProps(3)} />
      </Tabs>
      <TabPanel value={tabValue} index={0}>
        <form
          className="w-full"
          id="add-property-form"
          onSubmit={handleSubmitNamePrefix}
        >
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="md:flex md:items-center w-full mt-6">
              <div className="md:w-1/5">
                <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                  Name Prefix:<span title="Field is required."></span>
                </label>
              </div>
              <div className="md:w-1/5">
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="hoa_zip_code-property-name"
                  type="text"
                  value={prefix}
                  required={true}
                  onChange={(e) => {
                    setPrefix(e.target.value);
                  }}
                />
              </div>
              <input
                id={"form-submit-button"}
                type={"submit"}
                value="Add name prefix"
                hidden={false}
                className="ml-12 py-3 px-6 border-solid border-2  border-red-200 rounded"
              />
            </div>
          </div>
        </form>
        <form
          className="w-full"
          id="add-property-form"
          onSubmit={handleSubmitNameSuffix}
        >
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="md:flex md:items-center w-full mt-6">
              <div className="md:w-1/5">
                <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                  Name Suffix:<span title="Field is required."></span>
                </label>
              </div>
              <div className="md:w-1/5">
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="hoa_zip_code-property-name"
                  type="text"
                  value={suffix}
                  onChange={(e) => {
                    setSuffix(e.target.value);
                  }}
                />
              </div>
              <input
                id={"form-submit-button"}
                type={"submit"}
                value="Add name suffix"
                hidden={false}
                className="ml-12 py-3 px-6 border-solid border-2  border-red-200 rounded	"
              />
            </div>
          </div>
        </form>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <form
          className="w-full"
          id="add-property-form"
          onSubmit={handleSubmitParkingPrefix}
        >
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="md:flex md:items-center w-full mt-6">
              <div className="md:w-1/5">
                <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                  Parking Prefix:<span title="Field is required."></span>
                </label>
              </div>
              <div className="md:w-1/5">
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="hoa_zip_code-property-name"
                  type="text"
                  value={parkingPrefix}
                  onChange={(e) => {
                    setParkingPrefix(e.target.value);
                  }}
                />
              </div>
              <input
                id={"form-submit-button"}
                type={"submit"}
                value="Add parking prefix"
                hidden={false}
                className="ml-12 py-3 px-6 border-solid border-2  border-red-200 rounded"
              />
            </div>
          </div>
        </form>
        <form
          className="w-full"
          id="add-property-form"
          onSubmit={handleSubmitParkingSuffix}
        >
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="md:flex md:items-center w-full mt-6">
              <div className="md:w-1/5">
                <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                  Parking Suffix:<span title="Field is required."></span>
                </label>
              </div>
              <div className="md:w-1/5">
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="hoa_zip_code-property-name"
                  type="text"
                  value={parkingSuffix}
                  onChange={(e) => {
                    setParkingSuffix(e.target.value);
                  }}
                />
              </div>
              <input
                id={"form-submit-button"}
                type={"submit"}
                value="Add parking suffix"
                hidden={false}
                className="ml-12 py-3 px-6 border-solid border-2  border-red-200 rounded	"
              />
            </div>
          </div>
        </form>
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <form
          className="w-full"
          id="add-property-form"
          onSubmit={handleSubmitMoveOutReason}
        >
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="md:flex md:items-center w-full mt-6">
              <div className="md:w-1/5">
                <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                  Moveout reason:<span title="Field is required."></span>
                </label>
              </div>
              <div className="md:w-1/5">
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="hoa_zip_code-property-name"
                  type="text"
                  value={reason}
                  required={true}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                />
              </div>
              <input
                id={"form-submit-button"}
                type={"submit"}
                value="Add moveout reason"
                hidden={false}
                className="ml-12 py-3 px-6 border-solid border-2  border-red-200 rounded"
              />
            </div>
          </div>
        </form>
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <form
          className="w-full"
          id="add-property-form"
          onSubmit={handleSubmitEthnicities}
        >
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="md:flex md:items-center w-full mt-6">
              <div className="md:w-1/5">
                <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                  Ethnicity:<span title="Field is required."></span>
                </label>
              </div>
              <div className="md:w-1/5">
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="hoa_zip_code-property-name"
                  type="text"
                  value={ethnicity}
                  required={true}
                  onChange={(e) => {
                    setEthnicity(e.target.value);
                  }}
                />
              </div>
              <input
                id={"form-submit-button"}
                type={"submit"}
                value="Add  Ethnicity"
                hidden={false}
                className="ml-12 py-3 px-6 border-solid border-2  border-red-200 rounded"
              />
            </div>
          </div>
        </form>
      </TabPanel>
    </>
  );
};
